/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { ApiQuery } from '@app/core/http/api-query';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationService, HttpResponse } from '@app/core';
import { HttpClient } from '@angular/common/http';
import { Permission } from '@app/settings/users/permissionsns.model';
import { forEach } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  constructor(private http: HttpClient, private auth: AuthenticationService) {}

  index(): Observable<any> {
    const query: ApiQuery = new ApiQuery().setLimit(0);
    return this.http.get('v1/permissions', query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        const permissionsArray: {} = {};
        response.data.map((permission: any) => {
          // take permission group
          const permissionGroup = permission.name.split('.')[0];

          // create new key if not exist
          if (!permissionsArray[permissionGroup]) {
            permissionsArray[permissionGroup] = [];
          }

          // push permissions to array
          permissionsArray[permissionGroup].push(new Permission().deserialize(permission));
        });
        return permissionsArray;
      })
    );
  }
}
